export default {
    howToShop:'¿Cómo comprar?',
    howToShopLink:'como-comprar/electronica',
    help:'Ayuda',
    helpLink:'ayuda',
    returnTicket: 'Devolver pasaje',
    myPurchasesLink: 'usuario/miscompras',
    home: 'Home'
}